import { h } from 'preact';
import { useState } from 'preact/hooks';
import styles from './Tabs.module.scss';
export function Tabs({ tabs, activeId, onChange }) {
    var _a, _b;
    const [internalActive, setInternalActive] = useState(activeId || (tabs[0] && tabs[0].id));
    const currentActive = activeId !== null && activeId !== void 0 ? activeId : internalActive;
    const handleClick = (id) => {
        if (!activeId) {
            setInternalActive(id);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    };
    return (h("div", { class: `${styles.tabs} ${((_b = (_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a.styleMatches) === null || _b === void 0 ? void 0 : _b.length) > 0 ? styles.styleMatches : ''}`, style: { '--count-tabs': tabs.length || 6 } }, tabs.map((tab) => {
        var _a, _b;
        return (h("button", { type: "button", key: tab.id, class: `${styles.tabItem} ${((_b = (_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a.styleMatches) === null || _b === void 0 ? void 0 : _b.length) > 0 ? styles.styleMatchesTab : ''} ${tab.id === currentActive ? styles.tabItemActive : ''}`, onClick: () => { handleClick(tab.id); } }, tab.label));
    })));
}
